import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router";
import { RefreshCw } from "lucide-react";
import { ApiError } from "@baze/api-client";
import { Button } from "@/components/ui/button";
import { ErrorState } from "@/components/States";
import { isNotFound } from "@/lib/api";
import { t } from "@/i18n/id";
import { useDocumentTitle } from "@/lib/document-title";
import { NotFoundPage } from "./NotFoundPage";

/** Route-level error boundary with friendly Indonesian copy + retry. */
export function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();
  const missing = (isRouteErrorResponse(error) && error.status === 404) || isNotFound(error);
  useDocumentTitle(missing ? t.errors.notFoundTitle : t.errors.crashTitle);
  if ((isRouteErrorResponse(error) && error.status === 404) || isNotFound(error)) return <NotFoundPage inShell />;
  // Lazy chunk failed to load after a deploy → a reload fetches the new manifest.
  const chunk = error instanceof Error && /dynamically imported module|Importing a module script failed|Failed to fetch/i.test(error.message);
  if (error instanceof ApiError) {
    return (
      <div className="container-shell py-10">
        <ErrorState error={error} onRetry={() => navigate(0)} />
      </div>
    );
  }
  if (import.meta.env.DEV) console.error(error);
  return (
    <div role="alert" className="container-shell flex flex-col items-center gap-4 py-20 text-center">
      <h1 className="text-xl font-bold text-slate-900">{t.errors.crashTitle}</h1>
      <p className="max-w-md text-sm text-slate-500">{chunk ? t.errors.loadFailedBody : t.errors.crashBody}</p>
      <Button onClick={() => window.location.reload()} leftIcon={<RefreshCw aria-hidden="true" />}>
        {t.errors.reload}
      </Button>
    </div>
  );
}
